// react
import { useEffect, useState } from "react"
// functions
import {status_color_flag} from "../../Suport_functions"
// imgs
import escalera from "./escalera.png"


export default function PlantaBaja({ sala_resaltada, colores }) {
  const [Hall, SetHall] = useState({ color: colores.color_sala_desactivada, display: "none" })
  const [Sanitario, SetSanitario] = useState({ color: colores.color_sala_desactivada, display: "none" })
  const [Restaurante, SetRestaurante] = useState({ color: colores.color_sala_desactivada, display: "none" })
  const [Asensor, SetAsensor] = useState({ color: colores.color_sala_desactivada, display: "none" })

  useEffect(() => {
    SetHall(status_color_flag("Hall_Planta_Baja", sala_resaltada, colores));
    SetSanitario(status_color_flag("Sanitario_Planta_baja", sala_resaltada, colores));
    SetRestaurante(status_color_flag("Restaurante", sala_resaltada, colores));
    SetAsensor(status_color_flag("Asensor_Planta_Baja", sala_resaltada, colores));
  }, [sala_resaltada, colores]);


  return (
    <svg
      id="PlantaBaja"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x={0}
      y={0}
      viewBox="0 0 1684 1191"
      style={{
        enableBackground: "new 0 0 1684 1191",
      }}
      xmlSpace="preserve"
    >
      <style>
        {
          `#PlantaBaja .st2{font-family:'Montserrat-SemiBold'}
          #PlantaBaja .st6{font-size:32.2043px}
          #PlantaBaja .st7{fill:none;stroke:${Hall.color};stroke-width:6;stroke-linejoin:bevel;stroke-miterlimit:22.9256}
          #PlantaBaja .st9{fill:#221e73}
          #PlantaBaja .st10{fill:#fff}
          #PlantaBaja .st12{font-size:27px}
          #PlantaBaja .st16{fill-rule:evenodd;clip-rule:evenodd;fill:${Restaurante.color};stroke:${Restaurante.color};stroke-width:6;stroke-linejoin:bevel;stroke-miterlimit:22.9256}
          #PlantaBaja .st17{fill-rule:evenodd;clip-rule:evenodd;fill:${Sanitario.color};stroke:${Sanitario.color};stroke-width:6;stroke-linejoin:bevel;stroke-miterlimit:22.9256}`
        }
      </style>
      <g id="Oficinas">
        <path
          id="Color_oficina"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: colores.color_sala_desactivada,
            stroke: "#000",
            strokeWidth: 6,
            strokeMiterlimit: 10,
          }}
          d="M115.6 209.6h423.2V519l-213.3-1.8.1 171.3-207.2.4v15.4h-2.8z"
        />
      </g>
      <g id="ascensor">
        <g id="color_ascensor">
          <path
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: Asensor.color,
            }}
            d="m947.5 954.6-13.5-8.9v-30.6h84.9v30.6l-11.3 8.9z"
          />
          <path d="M1016.4 917.6v26.8l-9.7 7.7h-58.5l-11.8-7.8v-26.7h80m5-5h-89.9V947l15.3 10.1h61.7l12.9-10.3v-34.2z" />
        </g>
        <text
          transform="matrix(.7962 0 0 1 940.674 940.366)"
          className="st2"
          style={{
            fontSize: "19.6316px",
          }}
        >
          {"ascensor"}
        </text>
      </g>
      <g id="Hall_de_exposici\xF3n">
        <path
          id="color_hall"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: Hall.color,
            stroke: "#000",
            strokeWidth: 6,
            strokeMiterlimit: 22.9256,
          }}
          d="M534.3 209.6h598.9V914l-202 2.2.7 73H319.8l.2-75.2H115.6V683.2l206.3-.3-.1-167.9 212.5 1.8z"
        />
        <text transform="translate(621.326 576.504)" className="st2 st6">
          {"HALL DE EXPOSICI\xD3N"}
        </text>
        <path
          id="entrada_hall-afuera"
          className="st7"
          d="M692.3 989.2H576.4h115.9z"
        />
        <path
          id="entrada_hall-ascensor"
          className="st7"
          d="M1016.4 913.1zm-80.2 0h80.1-80.1z"
        />
        <path
          id="entrada_ascensor-hall"
          d="M1016.4 917.5zm-79.8 0h79.7-79.7z"
          style={{
            fill: "none",
            stroke:  Hall.color,
            strokeWidth: 3,
            strokeLinejoin: "bevel",
            strokeMiterlimit: 22.9256,
          }}
        />
        <image
          style={{
            overflow: "visible",
            enableBackground: "new",
          }}
          width={525}
          height={475}
          id="escalera_hall"
          xlinkHref={escalera}
          transform="translate(794.711 657.14) scale(.3113)"
        />
        <g id="bandera_hall" display={Hall.display}>
          <path
            id="palo"
            d="M760.4 438c-1.1-.2-1.8-1.3-1.6-2.4l27.9-146.8c.2-1.1 1.3-1.8 2.4-1.6 1.1.2 1.8 1.3 1.6 2.4l-27.9 146.8c-.2 1.1-1.3 1.8-2.4 1.6z"
          />
          <path
            id="fondo_bandera"
            className="st9"
            d="M892.6 394.6c-6.3 1.5-17.8 4.4-29.5-.7-28-12-59.3-26.1-89.7-22 4.5-23.8 9.1-47.7 13.6-71.5 40-2.3 80.2 20.2 119.2 22.6-4.6 23.9-9.1 47.7-13.6 71.6z"
          />
          <path
            id="borde_bandera"
            d="M871 397.5c-4.5-.8-9.1-2.3-13.7-4.2l-2.3-1c-25.8-11-52.4-22.3-81.4-18.4-.6.1-1.3-.1-1.7-.6-.4-.5-.6-1.1-.5-1.8L785 300c.2-.9.9-1.6 1.9-1.6 22.6-1.3 45.4 5.2 67.4 11.5 17.2 4.9 35 10 52.1 11.1.6 0 1.1.3 1.5.8.4.5.5 1 .4 1.6l-13.6 71.5c-.1.7-.6 1.3-1.3 1.5-6.7 2.3-14.3 2.7-22.4 1.1zm-65.4-26.4c17.7 3.4 34.5 10.5 51 17.6l2.3 1c11.6 5 22.9 6.2 31.9 3.4l12.9-68.1c-16.8-1.4-34-6.3-50.6-11.1-21.2-6.1-43.1-12.3-64.5-11.5l-12.8 67.3c10.3-1.2 20.2-.5 29.8 1.4zm86.9 23.5z"
          />
          <path
            className="st10"
            d="m800.7 338.7-.5 2.5c-4.3-.4-6.4-.4-10.8-.2 1-5.4 1.5-8.1 2.6-13.5 4.3-.2 6.4-.1 10.5.2l-.5 2.5c-2.9-.2-4.4-.3-7.3-.3-.2 1.2-.3 1.8-.6 2.9 2.6 0 3.9 0 6.5.2-.2 1-.3 1.5-.5 2.4-2.6-.2-3.9-.2-6.5-.2-.2 1.3-.4 1.9-.6 3.1 3.2.1 4.7.2 7.7.4zM803.5 341.4c-.8-.3-1.4-.6-1.8-1 .6-.8.9-1.2 1.4-2.1.4.3.9.7 1.6.9.6.3 1.3.4 1.9.5 1.3.2 2 0 2.1-.7.1-.3-.1-.5-.4-.7-.3-.2-.9-.4-1.6-.6-.8-.2-1.5-.5-2-.7s-1-.6-1.3-1.1c-.3-.5-.4-1.1-.3-1.9.1-.7.4-1.2.9-1.7s1.1-.8 1.9-1 1.7-.2 2.7-.1c.7.1 1.5.3 2.2.6.7.3 1.3.6 1.7 1-.6.8-.8 1.2-1.4 2-.8-.7-1.8-1.1-2.9-1.3-.6-.1-1.2-.1-1.5.1-.4.1-.6.3-.6.6-.1.3.1.6.4.7.3.2.9.4 1.6.6.8.3 1.5.5 2 .8.5.3.9.6 1.2 1.1.3.5.4 1.1.3 1.9-.1.6-.4 1.2-.9 1.6-.5.4-1.1.7-1.9.9-.8.2-1.7.2-2.7 0-.9.1-1.8-.1-2.6-.4zM819.6 344c-.3.1-.7.2-1.2.2-.4 0-.9 0-1.4-.2-1.2-.3-2.1-.8-2.7-1.6-.6-.8-.7-1.8-.5-3 .3-1.7.5-2.6.8-4.3-.6-.1-1-.2-1.6-.3.2-.9.3-1.4.4-2.3.6.1 1 .2 1.6.3l.5-2.5c1.2.2 1.8.4 3 .6l-.5 2.5c1 .2 1.5.3 2.6.6-.2.9-.3 1.4-.4 2.3-1-.2-1.5-.4-2.6-.6-.3 1.7-.5 2.5-.8 4.2-.1.4 0 .8.1 1.1.2.3.5.5.9.6.5.1.9.1 1.3-.1.2 1.1.3 1.6.5 2.5zM830.7 337.7c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.6-.8-.2-1.4-.5-2-1-.5-.4-.9-.9-1.1-1.5-.2-.6-.3-1.1-.2-1.7.2-1 .7-1.6 1.5-2 .8-.4 2-.4 3.5.1.9.3 1.4.4 2.4.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.1-1.1-.2-1.7-.2-.6 0-1.1.2-1.5.4-.3-1-.4-1.4-.7-2.4.6-.3 1.4-.4 2.2-.4.8 0 1.6.1 2.5.3 1.8.5 2.9 1.2 3.6 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.3-2-.6-1.2-.3-1.9-.1-2.1.7-.1.4 0 .7.3 1 .3.3.6.5 1.2.7.5.3 1 .3 1.4.1zM833.9 348.4c-.8-.5-1.4-.9-1.8-1.4.6-.7.8-1.1 1.4-1.9.4.4.9.8 1.5 1.2.6.4 1.2.7 1.8.9 1.2.4 1.9.3 2-.4.1-.3-.1-.6-.4-.8-.3-.2-.8-.5-1.5-.8-.8-.4-1.5-.7-2-1.1-.5-.3-.9-.8-1.2-1.3-.3-.5-.4-1.2-.3-2 .1-.7.4-1.2.9-1.6.5-.4 1.1-.6 1.9-.7s1.6.1 2.6.4c.7.2 1.4.5 2.1.9.7.4 1.2.8 1.6 1.2-.6.7-.8 1.1-1.4 1.8-.8-.8-1.7-1.4-2.8-1.7-.6-.2-1.1-.3-1.5-.2-.3.1-.6.3-.6.5-.1.3.1.6.4.8.3.2.8.5 1.6.9s1.5.8 2 1.1c.5.3.9.8 1.2 1.3.3.5.4 1.2.2 2-.1.6-.4 1.2-.9 1.5-.5.4-1.1.6-1.9.7-.8 0-1.7-.1-2.7-.4-.7-.1-1.5-.5-2.2-.9zM857.8 345.9c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.5-.8-.2-1.4-.6-2-1-.5-.4-.9-1-1.1-1.5-.2-.6-.3-1.2-.1-1.8.2-1 .7-1.6 1.5-2 .8-.3 2-.3 3.5.2.9.3 1.4.4 2.3.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.2-1.1-.2-1.6-.2-.6 0-1 .1-1.5.3-.3-1-.4-1.5-.7-2.4.6-.2 1.4-.3 2.2-.3.8 0 1.6.1 2.5.4 1.6.5 2.8 1.2 3.5 2.2zm-3.9 6.5c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.4-2-.6-1.2-.4-1.9-.1-2 .7-.1.4 0 .7.3 1.1.3.3.6.5 1.2.7.4.1.9.1 1.3 0zM872.5 348.4c-1.1 5.7-1.6 8.5-2.7 14.1-1.2-.2-1.8-.3-3-.6.4-1.9.6-2.9.9-4.8-.9.7-2 .9-3.3.6-1-.2-1.8-.7-2.5-1.3-.7-.6-1.2-1.4-1.5-2.3-.3-.9-.3-1.9-.1-3s.6-1.9 1.2-2.6c.6-.7 1.3-1.2 2.2-1.4.9-.2 1.8-.2 2.8 0 1.4.3 2.4 1 3 2.1.1-.5.1-.7.2-1.2 1.1.1 1.7.2 2.8.4zm-5.1 6.6c.6-.4 1-1.1 1.1-1.9.2-.9 0-1.6-.4-2.3-.4-.6-1-1-1.7-1.2-.8-.2-1.4-.1-2 .3-.6.4-1 1-1.1 1.9-.2.9-.1 1.6.3 2.3.4.6 1 1.1 1.7 1.2.9.2 1.5.1 2.1-.3zM885.9 350.1c-.8 4.2-1.2 6.2-2 10.4-1.2-.1-1.8-.1-2.9-.2.1-.5.1-.7.2-1.2-.5.4-1 .7-1.7.9-.6.2-1.2.2-1.9.1-1.4-.2-2.4-.7-3.1-1.6-.7-.9-.8-2.1-.5-3.7.4-2.3.7-3.5 1.1-5.9l3 .5c-.4 2.2-.6 3.3-1 5.4-.3 1.7.2 2.6 1.7 2.8.7.1 1.4-.1 1.9-.5s.9-1.1 1.1-2c.4-2.1.6-3.1 1-5.1 1.3 0 1.9 0 3.1.1zM892 346.2c1.3 0 2 0 3.4-.1-1.7 1.2-2.5 1.7-4.2 2.9h-2.4c1.3-1.2 1.9-1.7 3.2-2.8zm-3.2 4h3.1c-.8 4.2-1.2 6.2-2 10.4h-3.1c.8-4.1 1.2-6.2 2-10.4z"
          />
        </g>
      </g>
      <g id="Restaurante">
        <path
          id="color_restaurante"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: colores.color_sala_desactivada,
            stroke: "#000",
            strokeWidth: 6,
            strokeMiterlimit: 10,
          }}
          d="M1132.9 209.6h409.3v284.8h-409.3z"
        />
        {/* <text
          transform="matrix(1.0097 0 0 1 1245.428 356.494)"
          className="st2 st12"
        >
          {"RESTAURANTE"}
        </text> */}
      </g>
      <g id="salon_restaurante">
        <path
          id="color_salon"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: Restaurante.color,
            stroke: "#000",
            strokeWidth: 6,
            strokeMiterlimit: 10,
          }}
          d="M1132.9 494.4h409.3v419.5h-409.3z"
        />
        <text transform="translate(1300.744 692.013)" className="st2 st12">
          {"SAL\xD3N"}
        </text>
        <text transform="translate(1248.114 719.013)" className="st2 st12">
          {"RESTAURANTE"}
        </text>
        <path
          id="entrada_salon-afuera"
          d="M1283.7 911.7zm-84.1 1.4h84.1-84.1z"
          style={{
            fill: "none",
            stroke: Restaurante.color,
            strokeWidth: 8,
            strokeLinejoin: "bevel",
            strokeMiterlimit: 22.9256,
          }}
        />
        <path
          id="entrada_salon-hall"
          d="M1134.9 559.7zm0 83.7v-83.7 83.7z"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: Restaurante.color,
            stroke: Restaurante.color,
            strokeWidth: 6,
            strokeLinejoin: "bevel",
            strokeMiterlimit: 22.9256,
          }}
        />
        <path
          id="entrada_hall-salon"
          className="st16"
          d="M1130.6 559.7zm0 83.7v-83.7 83.7z"
        />
        <g id="bandera_salon_restaurante" display={Restaurante.display}>
          <path
            id="palo_2_"
            d="M1230 682.8c-1.1-.2-1.8-1.3-1.6-2.4l27.9-146.8c.2-1.1 1.3-1.8 2.4-1.6 1.1.2 1.8 1.3 1.6 2.4l-27.9 146.8c-.2 1.1-1.3 1.8-2.4 1.6z"
          />
          <path
            id="fondo_bandera_2_"
            className="st9"
            d="M1362.1 639.4c-6.3 1.5-17.8 4.4-29.5-.7-28-12-59.3-26.1-89.7-22 4.5-23.8 9.1-47.7 13.6-71.5 40-2.3 80.2 20.2 119.2 22.6-4.5 23.9-9 47.7-13.6 71.6z"
          />
          <path
            id="borde_bandera_2_"
            d="M1340.6 642.3c-4.5-.8-9.1-2.3-13.7-4.2l-2.3-1c-25.8-11-52.4-22.3-81.4-18.4-.6.1-1.3-.1-1.7-.6-.4-.5-.6-1.1-.5-1.8l13.6-71.5c.2-.9.9-1.6 1.9-1.6 22.6-1.3 45.4 5.2 67.4 11.5 17.2 4.9 35 10 52.1 11.1.6 0 1.1.3 1.5.8.4.5.5 1 .4 1.6l-13.6 71.5c-.1.7-.6 1.3-1.3 1.5-6.7 2.3-14.3 2.7-22.4 1.1zm-65.4-26.4c17.7 3.4 34.5 10.5 51 17.6l2.3 1c11.6 5 22.9 6.2 31.9 3.4l12.9-68.1c-16.8-1.4-34-6.3-50.6-11.1-21.2-6.1-43.1-12.3-64.5-11.5l-12.8 67.3c10.3-1.2 20.1-.5 29.8 1.4zm86.9 23.5z"
          />
          <path
            className="st10"
            d="m1270.3 583.5-.5 2.5c-4.3-.4-6.4-.4-10.8-.2 1-5.4 1.5-8.1 2.6-13.5 4.3-.2 6.4-.1 10.5.2l-.5 2.5c-2.9-.2-4.4-.3-7.3-.3-.2 1.2-.3 1.8-.6 2.9 2.6 0 3.9 0 6.5.2-.2 1-.3 1.5-.5 2.4-2.6-.2-3.9-.2-6.5-.2-.2 1.3-.4 1.9-.6 3.1 3.2.1 4.7.2 7.7.4zM1273.1 586.2c-.8-.3-1.4-.6-1.8-1 .6-.8.9-1.2 1.4-2.1.4.3.9.7 1.6.9.6.3 1.3.4 1.9.5 1.3.2 2 0 2.1-.7.1-.3-.1-.5-.4-.7-.3-.2-.9-.4-1.6-.6-.8-.2-1.5-.5-2-.7-.5-.2-1-.6-1.3-1.1-.3-.5-.4-1.1-.3-1.9.1-.7.4-1.2.9-1.7s1.1-.8 1.9-1c.8-.2 1.7-.2 2.7-.1.7.1 1.5.3 2.2.6.7.3 1.3.6 1.7 1-.6.8-.8 1.2-1.4 2-.8-.7-1.8-1.1-2.9-1.3-.6-.1-1.2-.1-1.5.1-.4.1-.6.3-.6.6-.1.3.1.6.4.7.3.2.9.4 1.6.6.8.3 1.5.5 2 .8.5.3.9.6 1.2 1.1.3.5.4 1.1.3 1.9-.1.6-.4 1.2-.9 1.6-.5.4-1.1.7-1.9.9-.8.2-1.7.2-2.7 0-1 .1-1.8-.1-2.6-.4zM1289.2 588.8c-.3.1-.7.2-1.2.2-.4 0-.9 0-1.4-.2-1.2-.3-2.1-.8-2.7-1.6-.6-.8-.7-1.8-.5-3 .3-1.7.5-2.6.8-4.3-.6-.1-1-.2-1.6-.3.2-.9.3-1.4.4-2.3.6.1 1 .2 1.6.3l.5-2.5c1.2.2 1.8.4 3 .6l-.5 2.5c1 .2 1.5.3 2.6.6-.2.9-.3 1.4-.4 2.3-1-.2-1.5-.4-2.6-.6-.3 1.7-.5 2.5-.8 4.2-.1.4 0 .8.1 1.1.2.3.5.5.9.6.5.1.9.1 1.3-.1.2 1.1.3 1.6.5 2.5zM1300.3 582.5c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.6-.8-.2-1.4-.5-2-1-.5-.4-.9-.9-1.1-1.5-.2-.6-.3-1.1-.2-1.7.2-1 .7-1.6 1.5-2 .8-.4 2-.4 3.5.1.9.3 1.4.4 2.4.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.1-1.1-.2-1.7-.2-.6 0-1.1.2-1.5.4-.3-1-.4-1.4-.7-2.4.6-.3 1.4-.4 2.2-.4.8 0 1.6.1 2.5.3 1.8.5 2.9 1.2 3.6 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.3-2-.6-1.2-.3-1.9-.1-2.1.7-.1.4 0 .7.3 1 .3.3.6.5 1.2.7.5.3 1 .3 1.4.1zM1303.4 593.2c-.8-.5-1.4-.9-1.8-1.4.6-.7.8-1.1 1.4-1.9.4.4.9.8 1.5 1.2.6.4 1.2.7 1.8.9 1.2.4 1.9.3 2-.4.1-.3-.1-.6-.4-.8-.3-.2-.8-.5-1.5-.8-.8-.4-1.5-.7-2-1.1-.5-.3-.9-.8-1.2-1.3-.3-.5-.4-1.2-.3-2 .1-.7.4-1.2.9-1.6.5-.4 1.1-.6 1.9-.7.8-.1 1.6.1 2.6.4.7.2 1.4.5 2.1.9.7.4 1.2.8 1.6 1.2-.6.7-.8 1.1-1.4 1.8-.8-.8-1.7-1.4-2.8-1.7-.6-.2-1.1-.3-1.5-.2-.3.1-.6.3-.6.5-.1.3.1.6.4.8.3.2.8.5 1.6.9s1.5.8 2 1.1c.5.3.9.8 1.2 1.3.3.5.4 1.2.2 2-.1.6-.4 1.2-.9 1.5-.5.4-1.1.6-1.9.7-.8 0-1.7-.1-2.7-.4-.6-.1-1.4-.5-2.2-.9zM1327.4 590.7c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.5-.8-.2-1.4-.6-2-1-.5-.4-.9-1-1.1-1.5-.2-.6-.3-1.2-.1-1.8.2-1 .7-1.6 1.5-2 .8-.3 2-.3 3.5.2.9.3 1.4.4 2.3.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.2-1.1-.2-1.6-.2-.6 0-1 .1-1.5.3-.3-1-.4-1.5-.7-2.4.6-.2 1.4-.3 2.2-.3.8 0 1.6.1 2.5.4 1.6.5 2.8 1.2 3.5 2.2zm-3.9 6.5c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.4-2-.6-1.2-.4-1.9-.1-2 .7-.1.4 0 .7.3 1.1.3.3.6.5 1.2.7.4.1.9.1 1.3 0zM1342.1 593.2c-1.1 5.7-1.6 8.5-2.7 14.1-1.2-.2-1.8-.3-3-.6.4-1.9.6-2.9.9-4.8-.9.7-2 .9-3.3.6-1-.2-1.8-.7-2.5-1.3-.7-.6-1.2-1.4-1.5-2.3-.3-.9-.3-1.9-.1-3 .2-1.1.6-1.9 1.2-2.6.6-.7 1.3-1.2 2.2-1.4.9-.2 1.8-.2 2.8 0 1.4.3 2.4 1 3 2.1.1-.5.1-.7.2-1.2 1.1.1 1.7.2 2.8.4zm-5.1 6.6c.6-.4 1-1.1 1.1-1.9.2-.9 0-1.6-.4-2.3-.4-.6-1-1-1.7-1.2-.8-.2-1.4-.1-2 .3-.6.4-1 1-1.1 1.9-.2.9-.1 1.6.3 2.3.4.6 1 1.1 1.7 1.2.9.2 1.5.1 2.1-.3zM1355.5 594.9c-.8 4.2-1.2 6.2-2 10.4-1.2-.1-1.8-.1-2.9-.2.1-.5.1-.7.2-1.2-.5.4-1 .7-1.7.9-.6.2-1.2.2-1.9.1-1.4-.2-2.4-.7-3.1-1.6-.7-.9-.8-2.1-.5-3.7.4-2.3.7-3.5 1.1-5.9l3 .5c-.4 2.2-.6 3.3-1 5.4-.3 1.7.2 2.6 1.7 2.8.7.1 1.4-.1 1.9-.5s.9-1.1 1.1-2c.4-2.1.6-3.1 1-5.1 1.3 0 1.9 0 3.1.1zM1361.6 591c1.3 0 2 0 3.4-.1-1.7 1.2-2.5 1.7-4.2 2.9h-2.4c1.3-1.2 1.9-1.7 3.2-2.8zm-3.2 4h3.1c-.8 4.2-1.2 6.2-2 10.4h-3.1c.8-4.1 1.2-6.2 2-10.4z"
          />
        </g>
      </g>
      <g id="Sanitario">
        <path
          id="color_sanitario"
          style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: Sanitario.color,
            stroke: "#000",
            strokeWidth: 6,
            strokeMiterlimit: 22.9256,
          }}
          d="M115.6 718.8H320v194.9H115.6z"
        />
        <text transform="translate(131.197 816.25)" className="st2 st12">
          {"SANITARIOS"}
        </text>
        <path
          id="entrada_hall-sanitarios_2"
          className="st17"
          d="M320 723.1zm0 46.9v-47 47z"
        />
        <path
          id="entrada_hall-sanitarios_1"
          className="st17"
          d="M320 860.2zm0 47v-47 47z"
        />
        <g id="bandera_sanitario" display={Sanitario.display}>
          <path
            id="palo_1_"
            d="M162.8 880.4c-1.1-.2-1.8-1.3-1.6-2.4l27.9-146.8c.2-1.1 1.3-1.8 2.4-1.6 1.1.2 1.8 1.3 1.6 2.4l-27.9 146.8c-.2 1.1-1.3 1.8-2.4 1.6z"
          />
          <path
            id="fondo_bandera_1_"
            className="st9"
            d="M295 836.9c-6.3 1.5-17.8 4.4-29.5-.7-28-12-59.3-26.1-89.7-22 4.5-23.8 9.1-47.7 13.6-71.5 40-2.3 80.2 20.2 119.2 22.6-4.6 23.9-9.1 47.8-13.6 71.6z"
          />
          <path
            id="borde_bandera_1_"
            d="M273.4 839.9c-4.5-.8-9.1-2.3-13.7-4.2l-2.3-1c-25.8-11-52.4-22.3-81.4-18.4-.6.1-1.3-.1-1.7-.6-.4-.5-.6-1.1-.5-1.8l13.6-71.5c.2-.9.9-1.6 1.9-1.6 22.6-1.3 45.4 5.2 67.4 11.5 17.2 4.9 35 10 52.1 11.1.6 0 1.1.3 1.5.8.4.5.5 1 .4 1.6l-13.6 71.5c-.1.7-.6 1.3-1.3 1.5-6.7 2.3-14.3 2.6-22.4 1.1zM208 813.4c17.7 3.4 34.5 10.5 51 17.6l2.3 1c11.6 5 22.9 6.2 31.9 3.4l12.9-68.1c-16.8-1.4-34-6.3-50.6-11.1-21.2-6.1-43.1-12.3-64.5-11.5L178.2 812c10.3-1.1 20.2-.4 29.8 1.4zm86.9 23.5z"
          />
          <path
            className="st10"
            d="m203.1 781.1-.5 2.5c-4.3-.4-6.4-.4-10.8-.2 1-5.4 1.5-8.1 2.6-13.5 4.3-.2 6.4-.1 10.5.2l-.5 2.5c-2.9-.2-4.4-.3-7.3-.3-.2 1.2-.3 1.8-.6 2.9 2.6 0 3.9 0 6.5.2-.2 1-.3 1.5-.5 2.4-2.6-.2-3.9-.2-6.5-.2-.2 1.3-.4 1.9-.6 3.1 3.2.1 4.7.2 7.7.4zM205.9 783.8c-.8-.3-1.4-.6-1.8-1 .6-.8.9-1.2 1.4-2.1.4.3.9.7 1.6.9.6.3 1.3.4 1.9.5 1.3.2 2 0 2.1-.7.1-.3-.1-.5-.4-.7s-.9-.4-1.6-.6c-.8-.2-1.5-.5-2-.7s-1-.6-1.3-1.1c-.3-.5-.4-1.1-.3-1.9.1-.7.4-1.2.9-1.7s1.1-.8 1.9-1 1.7-.2 2.7-.1c.7.1 1.5.3 2.2.6.7.3 1.3.6 1.7 1-.6.8-.8 1.2-1.4 2-.8-.7-1.8-1.1-2.9-1.3-.6-.1-1.2-.1-1.5.1-.4.1-.6.3-.6.6-.1.3.1.6.4.7.3.2.9.4 1.6.6.8.3 1.5.5 2 .8.5.3.9.6 1.2 1.1.3.5.4 1.1.3 1.9-.1.6-.4 1.2-.9 1.6-.5.4-1.1.7-1.9.9-.8.2-1.7.2-2.7 0-.9.1-1.8-.1-2.6-.4zM222 786.4c-.3.1-.7.2-1.2.2-.4 0-.9 0-1.4-.2-1.2-.3-2.1-.8-2.7-1.6-.6-.8-.7-1.8-.5-3 .3-1.7.5-2.6.8-4.3-.6-.1-1-.2-1.6-.3.2-.9.3-1.4.4-2.3.6.1 1 .2 1.6.3l.5-2.5c1.2.2 1.8.4 3 .6l-.5 2.5c1 .2 1.5.3 2.6.6-.2.9-.3 1.4-.4 2.3-1-.2-1.5-.4-2.6-.6-.3 1.7-.5 2.5-.8 4.2-.1.4 0 .8.1 1.1.2.3.5.5.9.6.5.1.9.1 1.3-.1.2 1.1.3 1.6.5 2.5zM233.1 780.1c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.6-.8-.2-1.4-.5-2-1-.5-.4-.9-.9-1.1-1.5-.2-.6-.3-1.1-.2-1.7.2-1 .7-1.6 1.5-2 .8-.4 2-.4 3.5.1.9.3 1.4.4 2.4.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.1-1.1-.2-1.7-.2-.6 0-1.1.2-1.5.4-.3-1-.4-1.4-.7-2.4.6-.3 1.4-.4 2.2-.4.8 0 1.6.1 2.5.3 1.8.4 2.9 1.2 3.6 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.3-2-.6-1.2-.3-1.9-.1-2.1.7-.1.4 0 .7.3 1 .3.3.6.5 1.2.7.5.2 1 .2 1.4.1zM236.3 790.8c-.8-.5-1.4-.9-1.8-1.4.6-.7.8-1.1 1.4-1.9.4.4.9.8 1.5 1.2.6.4 1.2.7 1.8.9 1.2.4 1.9.3 2-.4.1-.3-.1-.6-.4-.8-.3-.2-.8-.5-1.5-.8-.8-.4-1.5-.7-2-1.1-.5-.3-.9-.8-1.2-1.3-.3-.5-.4-1.2-.3-2 .1-.7.4-1.2.9-1.6.5-.4 1.1-.6 1.9-.7s1.6.1 2.6.4c.7.2 1.4.5 2.1.9.7.4 1.2.8 1.6 1.2-.6.7-.8 1.1-1.4 1.8-.8-.8-1.7-1.4-2.8-1.7-.6-.2-1.1-.3-1.5-.2-.3.1-.6.3-.6.5-.1.3.1.6.4.8.3.2.8.5 1.6.9s1.5.8 2 1.1c.5.3.9.8 1.2 1.3.3.5.4 1.2.2 2-.1.6-.4 1.2-.9 1.5-.5.4-1.1.6-1.9.7-.8 0-1.7-.1-2.7-.4-.7-.1-1.5-.5-2.2-.9zM260.2 788.3c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.5-.8-.2-1.4-.6-2-1-.5-.4-.9-1-1.1-1.5-.2-.6-.3-1.2-.1-1.8.2-1 .7-1.6 1.5-2 .8-.3 2-.3 3.5.2.9.3 1.4.4 2.3.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.2-1.1-.2-1.6-.2-.6 0-1 .1-1.5.3-.3-1-.4-1.5-.7-2.4.6-.2 1.4-.3 2.2-.3.8 0 1.6.1 2.5.4 1.6.5 2.8 1.2 3.5 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.4-2-.6-1.2-.4-1.9-.1-2 .7-.1.4 0 .7.3 1.1.3.3.6.5 1.2.7.4.2.9.2 1.3 0zM274.9 790.8c-1.1 5.7-1.6 8.5-2.7 14.1-1.2-.2-1.8-.3-3-.6.4-1.9.6-2.9.9-4.8-.9.7-2 .9-3.3.6-1-.2-1.8-.7-2.5-1.3s-1.2-1.4-1.5-2.3c-.3-.9-.3-1.9-.1-3s.6-1.9 1.2-2.6c.6-.7 1.3-1.2 2.2-1.4.9-.2 1.8-.2 2.8 0 1.4.3 2.4 1 3 2.1.1-.5.1-.7.2-1.2 1.1.1 1.7.2 2.8.4zm-5.1 6.5c.6-.4 1-1.1 1.1-1.9.2-.9 0-1.6-.4-2.3-.4-.6-1-1-1.7-1.2-.8-.2-1.4-.1-2 .3-.6.4-1 1-1.1 1.9-.2.9-.1 1.6.3 2.3.4.6 1 1.1 1.7 1.2.9.3 1.5.1 2.1-.3zM288.3 792.5c-.8 4.2-1.2 6.2-2 10.4-1.2-.1-1.8-.1-2.9-.2.1-.5.1-.7.2-1.2-.5.4-1 .7-1.7.9-.6.2-1.2.2-1.9.1-1.4-.2-2.4-.7-3.1-1.6-.7-.9-.8-2.1-.5-3.7.4-2.3.7-3.5 1.1-5.9l3 .5c-.4 2.2-.6 3.3-1 5.4-.3 1.7.2 2.6 1.7 2.8.7.1 1.4-.1 1.9-.5s.9-1.1 1.1-2c.4-2.1.6-3.1 1-5.1 1.3 0 1.9 0 3.1.1zM294.4 788.5c1.3 0 2 0 3.4-.1-1.7 1.2-2.5 1.7-4.2 2.9h-2.4c1.3-1.1 1.9-1.6 3.2-2.8zm-3.2 4.1h3.1c-.8 4.2-1.2 6.2-2 10.4h-3.1c.8-4.1 1.2-6.2 2-10.4z"
          />
        </g>
      </g>
      <text
        id="titulo"
        transform="translate(520 150)"
        className="st2"
        style={{
          fontSize: 90,
          fill: "#ffffff"
        }}
      >
        {"PLANTA BAJA"}
      </text>
    </svg>
  )
}
